import { render, staticRenderFns } from "./ControllerTable.vue?vue&type=template&id=50659eac&"
import script from "./ControllerTable.vue?vue&type=script&lang=js&"
export * from "./ControllerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports